import { workflowConstants } from '../_constants'
import { history } from '../_helpers';

export const workflowService = {
    startWorkflow,
    nextStep,
    previousStep,
    getCurrentWorkflowStepData,
    getWorkflowById
}

const storageName = "workflowData";

const newLoanWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/GetStarted", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/PersonalInfo", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/FinancialInfo", isLastStep: false },
    { stepId: 3, stepperStepId: 3, path: "/FundingSelection", isLastStep: false },
    { stepId: 4, stepperStepId: 4, path: "/ConfirmationSummary", isLastStep: false },
    { stepId: 5, stepperStepId: 5, path: "/SignUpCreatePassword", isLastStep: true },
    //{ stepId: 6, stepperStepId: 4, path: "/SignUpConfirmationSummary", isLastStep: false },

];

const newLoanLoggedInWorkflow = [ 
    { stepId: 0, stepperStepId: 0, path: "/FundingAmount", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/ConfirmationSummary", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/Confirmation", isLastStep: true },
    { stepId: 3, stepperStepId: 3, path: "/", isLastStep: false }
];

const newLoanLandingPageWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/Welcome", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/ConfirmationSummary", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/SignUpCreatePassword", isLastStep: true },
    //{ stepId: 4, stepperStepId: 4, path: "/SignUpConfirmationSummary", isLastStep: false },
];

const refinancePageWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/Refinance/SelectLoan", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/Refinance/PersonalInfo", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/Refinance/FinancialInfo", isLastStep: false },
    { stepId: 3, stepperStepId: 3, path: "/Refinance/FundingSelection", isLastStep: false },
    { stepId: 4, stepperStepId: 4, path: "/Refinance/Summary", isLastStep: true },
    // { stepId: 5, stepperStepId: 5, path: "/Refinance/Contract", isLastStep: true },
];
const applicationReceivedWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/SignUpCreatePassword", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/SignUpEmailValidation", isLastStep: false }, 
    { stepId: 2, stepperStepId: 2, path: "/my-account", isLastStep: true },
];

const existingCustomerRegistrationWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/SignUpVerifyIdentity", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/SignUpCreatePassword", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/SignUpEmailValidation", isLastStep: false },
    { stepId: 3, stepperStepId: 3, path: "/", isLastStep: true },
]

const guestPaymentRegistrationWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/SignUpCreatePassword", isLastStep: false },
    { stepId: 1, stepperStepId: 1, path: "/SignUpEmailValidation", isLastStep: false },
    { stepId: 2, stepperStepId: 2, path: "/", isLastStep: true },
]

const refinancePageDisabledFundingWorkflow = [
    { stepId: 0, stepperStepId: 0, path: "/Refinance/SelectLoan", isLastStep: false },
    { stepId: 1, stepperStepId:1, path: "/Refinance/Summary", isLastStep: true },
];

const workFlows = [
    { workflowId: workflowConstants.NEW_LOAN_WORKFLOW, workflow: newLoanWorkflow }, //new user request
    { workflowId: workflowConstants.NEW_LOAN_LOGGED_IN_WORKFLOW, workflow: newLoanLoggedInWorkflow }, //logged in user request
    { workflowId: workflowConstants.NEW_LOAN_LANDING_PAGE_WORKFLOW, workflow: newLoanLandingPageWorkflow }, //lead envy
    { workflowId: workflowConstants.REFINANCE_INCREASE_LOAN_WORKFLOW, workflow: refinancePageWorkflow }, // Refinance
    { workflowId: workflowConstants.APPLICATION_RECEIVED_WORKFLOW, workflow: applicationReceivedWorkflow }, // Refinance
    { workflowId: workflowConstants.EXISTING_CUSTOMER_REGISTRATION_WORKFLOW, workflow: existingCustomerRegistrationWorkflow }, //existing customer registration
    { workflowId: workflowConstants.REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW, workflow: refinancePageDisabledFundingWorkflow }, // Refinance with disabled funding selection
    { workflowId: workflowConstants.GUEST_PAYMENT_REGISTRATION, workflow: guestPaymentRegistrationWorkflow }, // Registration after making unauthenticated payment
];

function storeWorkflowDataObject(workflowId, stepId) {
     
    let workflow = getWorkflowById(workflowId);

    let workflowStep = workflow.workflow.find(step => step.stepId === stepId);

    let storageObject = {
        workflowId: workflowId,
        currentStep: stepId,
        currentStepperStep: workflowStep.stepperStepId,
        canMoveBack: canMoveBack(stepId),
        canMoveForward: canMoveForward(workflowId, stepId)
    };

    sessionStorage.setItem(storageName, JSON.stringify(storageObject));
}

function removeWorkflowDataObject() {
    sessionStorage.removeItem(storageName);
}

function canMoveForward(workflowId, stepId) {
    let workflow = getWorkflowById(workflowId);
    let maxStep = workflow.workflow.length - 1;
    return maxStep !== stepId;
}

function canMoveBack(stepId) {
    return 0 !== stepId;
}

function isLastStep(workflowId, stepId) {
    let workflow = getWorkflowById(workflowId);
    let workflowStep = workflow.workflow.find(step => step.stepId === stepId);

    return workflowStep.isLastStep;
}

function getWorkflowById(id) {
    return workFlows.find(wf => wf.workflowId === id);
}

function startWorkflow(workflowId, dispatch, request, failure, data) {
    try {
        let workflow = getWorkflowById(workflowId);
        let workflowStep = workflow.workflow.find(step => step.stepId === 0);

        if (data) {
            dispatch(request(data));
        }
        else {
            dispatch(request());
        }

        storeWorkflowDataObject(workflowId, workflowStep.stepId);

        history.push(workflowStep.path);

    } catch (errorString) {
        dispatch(failure(errorString));
    }
}

function nextStep(dispatch, request, failure, data) {
    try {
        let currentStepData = getCurrentWorkflowStepData();

        if (data) {
            dispatch(request(data));
        }
        else {
            dispatch(request());
        }
        if (isLastStep(currentStepData.workflowId, currentStepData.currentStep)) {
            //todo: you are already on the last step. cleanup
            let workflow = getWorkflowById(currentStepData.workflowId);
            let workflowStep = workflow.workflow.find(step => step.stepId === (currentStepData.currentStep + 1));
            // removeWorkflowDataObject();
            history.push(workflowStep.path);
        }
        else {
            let workflow = getWorkflowById(currentStepData.workflowId);
            let workflowStep = workflow.workflow.find(step => step.stepId === (currentStepData.currentStep + 1));
            storeWorkflowDataObject(currentStepData.workflowId, workflowStep.stepId);

            history.push(workflowStep.path);
        }
    } catch (errorString) {
        dispatch(failure(errorString))
    }
}

function previousStep(dispatch, request, failure, data) {
    try {
        let currentStepData = getCurrentWorkflowStepData();

        if (data) {
            dispatch(request(data));
        }
        else {
            dispatch(request());
        }

        if (!canMoveBack(currentStepData.currentStep)) {
            throw new Error("This is the start of the workflow. Cannot move back.");
        }
        else {
            let workflow = getWorkflowById(currentStepData.workflowId);
            let workflowStep = workflow.workflow.find(step => step.stepId === (currentStepData.currentStep - 1));
            storeWorkflowDataObject(currentStepData.workflowId, workflowStep.stepId);

            history.push(workflowStep.path);
        }
    } catch (errorString) {
        dispatch(failure(errorString))
    }
}

function getCurrentWorkflowStepData() {
    return JSON.parse(sessionStorage.getItem(storageName));
}


// WEBPACK FOOTER //
// ./src/_services/workflow.service.js